// extracted by mini-css-extract-plugin
export default {"numberInputContainer":"G4Yv6w"};